import ExtendableError from '../lib/ExtendableError';

export class CustomerEmailInUseError extends ExtendableError { name = 'CustomerEmailInUseError' }
export class CustomerRegistrationError extends ExtendableError { name = 'CustomerRegistrationError' }
export class CustomerLoginError extends ExtendableError { name = 'CustomerLoginError' }
export class CustomerRefreshError extends ExtendableError { name = 'CustomerRefreshError' }

export class CustomerMaxFailedLoginAttemptsReached extends CustomerLoginError {
    name = 'CustomerMaxFailedLoginAttemptsReached';
    static code = 8034;
}

export class CustomerAccountDormant extends CustomerLoginError {
    name = 'CustomerAccountDormant';
    static code = 8035;
}

export class CustomerAccountLocked extends CustomerLoginError {
    name = 'CustomerAccountLocked';
    static code = 8036;
}


// WEBPACK FOOTER //
// ./src/errors/Customer.js